export const formatTime = (time, is24Hour) => {
  if (!time) return "";
  const [h, m] = time.split(":");
  const date = new Date();
  date.setHours(h, m);
  return is24Hour
    ? `${h}:${m}`
    : date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
};
